import { jsx as _jsx } from "react/jsx-runtime";
var Copy = function Copy(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.46375 13.5127V12.5127C9.46375 10.8587 10.8097 9.5127 12.4637 9.5127H13.4637V6.1797C13.4637 5.8117 13.1647 5.5127 12.7967 5.5127H6.13075C5.76275 5.5127 5.46375 5.8117 5.46375 6.1797V12.8457C5.46375 13.2137 5.76275 13.5127 6.13075 13.5127H9.46375ZM9.46375 15.5127H6.13075C4.65975 15.5127 3.46375 14.3167 3.46375 12.8457V6.1797C3.46375 4.7087 4.65975 3.5127 6.13075 3.5127H12.7967C14.2677 3.5127 15.4637 4.7087 15.4637 6.1797V9.5127H18.4637C20.1177 9.5127 21.4637 10.8587 21.4637 12.5127V18.5127C21.4637 20.1667 20.1177 21.5127 18.4637 21.5127H12.4637C10.8097 21.5127 9.46375 20.1667 9.46375 18.5127V15.5127ZM11.4637 12.5127C11.4637 11.9617 11.9127 11.5127 12.4637 11.5127H18.4637C19.0157 11.5127 19.4637 11.9617 19.4637 12.5127V18.5127C19.4637 19.0637 19.0157 19.5127 18.4637 19.5127H12.4637C11.9127 19.5127 11.4637 19.0637 11.4637 18.5127V12.5127Z",
      fill: color
    })
  });
};
export default Copy;